const baseUrls = {
  GatewayUsersApiBaseUrl: `${import.meta.env.REACT_APP_API_GATEWAY_USERS_URL}/users/api`,
  PapiReactApiBaseUrl: `${import.meta.env.REACT_APP_API_GATEWAY_BASE_URL}/papi-react-api/api`,
  GatewayBaseUrl: `${import.meta.env.REACT_APP_API_GATEWAY_BASE_URL}/healthplans-api/api`,
  StaticGatewayBaseUrl: `${import.meta.env.REACT_APP_API_GATEWAY_BASE_URL}/static-api/api`,
  DoctorSearchUrl: `${import.meta.env.REACT_APP_API_GATEWAY_BASE_URL}/doctors-search-api/api`,
  AccountManagementURL: `${import.meta.env.REACT_APP_API_GATEWAY_BASE_URL}/account-management-api/api`,
  PharmaciesSearchUrl: `${import.meta.env.REACT_APP_API_GATEWAY_BASE_URL}/epharmacy/api`,
  MedicalServicesApiBaseUrl: `${import.meta.env.REACT_APP_API_GATEWAY_BASE_URL}/medical-services-api/api`,
  PharmacyInventoryApiBaseUrl:
    import.meta.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL ||
    'https://service.vezeeta.com/inventory/api',
};

const urls = {
  accountManagementUrls: {
    getApiAuthToken: `${baseUrls.GatewayUsersApiBaseUrl}/logins/externallogin`,
  },
  healthPlansApi: {
    getInsuranceCompany: `${baseUrls.GatewayBaseUrl}/insurancecompanies`,
    HealthPlans: `${baseUrls.GatewayBaseUrl}/healthplans`,
  },
  categoriesApi: {
    priceLists: `${baseUrls.GatewayBaseUrl}/pricelists`,
    providers: `${baseUrls.GatewayBaseUrl}/pricelistsproviders`,
    dropdowns: `${baseUrls.PapiReactApiBaseUrl}/generic/getdropdowns`,
    areas: `${baseUrls.StaticGatewayBaseUrl}/areas`,
    branches: `${baseUrls.AccountManagementURL}/branches`,
    pharmacies: `${baseUrls.PharmaciesSearchUrl}/v2/pharmacies`,
    pharmacyProducts: `${baseUrls.PharmacyInventoryApiBaseUrl}/v2/products`,
    services: `${baseUrls.GatewayBaseUrl}/pricelistconfigurations`,
    medicalServices: `${baseUrls.MedicalServicesApiBaseUrl}/services`,
    searchEntities: `${baseUrls.AccountManagementURL}/entities`,
    entityProviders: `${baseUrls.GatewayBaseUrl}/providerbenefits`,
    addEntityProvider: `${baseUrls.GatewayBaseUrl}/providerbenefits`,
    editEntityProvider: `${baseUrls.GatewayBaseUrl}/providerbenefits`,
    deleteEntityProvider: `${baseUrls.GatewayBaseUrl}/providerbenefits`,
  },
  search: {
    searchDoctor: `${baseUrls.DoctorSearchUrl}/search`,
    doctorProfile: `${baseUrls.DoctorSearchUrl}/doctorprofile`,
  },
  common: {
    getCountries: `${baseUrls.StaticGatewayBaseUrl}/country/getallcountries`,
  },
};

export default urls;
